import { LucideIcon } from "lucide-react";

export interface TextSelection {
  start: number;
  end: number;
  text: string;
}

export interface FileAttachment {
  id: string;
  messageId: string;
  fileName: string;
  fileType: 'image' | 'pdf' | 'document' | 'text' | 'other';
  fileSize: number;
  storagePath: string;
  dataUrl?: string;
  textContent?: string;
  color: string;
  number: number;
  textSelections: TextSelection[];
  metadata?: {
    dimensions?: { width: number; height: number };
    pageCount?: number;
  };
  createdAt: string;
  deleted?: boolean;
}

export const ATTACHMENT_COLORS = [
  'blue', 'green', 'purple', 'orange', 'pink', 'yellow', 'red', 'cyan'
] as const;

export type AttachmentColor = typeof ATTACHMENT_COLORS[number];
